export default [
  {
    path: '/survey/:session',
    name: 'public_survey',
    props: true,
    component: () => import('@/views/PublicSurvey'),
  },
]
